import { getIsSystemMessage, type Msg } from '@halo/chat-sdk-react';
import { MessageItem } from '@halo/ui-chat-react';
import { useIsMyMsg } from '@/scripts/hooks';

export interface MsgItemProps {
  message: Msg;
  children: React.ReactNode;
}

export const MsgItem = memo(function MsgItem({ message, children }: MsgItemProps) {
  const isMyMessage = useIsMyMsg(message);
  const isSystem = useMemo(() => getIsSystemMessage(message), [message]);

  return (
    <MessageItem
      isSystem={isSystem}
      isMe={isMyMessage}
      msgId={message.message_id}
      cliMsgId={message.cli_msg_id}
    >
      {children}
    </MessageItem>
  );
});
